
import React from "react";
// import "./pagestyles/Economics.css"; // 👈 reuse same CSS

const LiveTv = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Live TV</h1>
        <p className="page-subtitle">
          Watch Redbox Global live coverage and breaking news
        </p>
      </div>

      <div className="page-content">
        <div className="content-grid">

          <div className="article-card">
            <div className="article-image">
              <img
                src="https://images.unsplash.com/photo-1598550476439-6847785fcea6?w=600&h=400&fit=crop"
                alt="Live Broadcast"
              />
            </div>
            <div className="article-content">
              {/* <span className="article-category">Live</span> */}
              <h2>Redbox Global Live News Stream</h2>
              <p>
                Stay updated with real-time global coverage, expert analysis,
                and market insights.
              </p>
              <span className="article-meta">Streaming Now</span>
            </div>
          </div>

          <div className="article-card">
            <div className="article-image">
              <img
                src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=600&h=400&fit=crop"
                alt="Markets Live"
              />
            </div>
            <div className="article-content">
              {/* <span className="article-category">Markets</span> */}
              <h2>Markets Live Coverage</h2>
              <p>
                Watch real-time updates from global financial markets and expert commentary.
              </p>
              <span className="article-meta">Weekdays 9AM - 5PM</span>
            </div>
          </div>

          <div className="article-card">
          <div className="article-image">
         <img
           src="https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=1200&h=630&fit=crop"
            alt="Breaking News Live"
           />
       </div>
       <div className="article-content">
       {/* <span className="article-category">Breaking</span> */}
         <h2>Breaking News Special Coverage</h2>
        <p>
         Live special coverage of major global developments with expert panel discussions.
        </p>
       <span className="article-meta">Live Events</span>
        </div>
       </div>

        </div>
      </div>
    </div>
  );
};

export default LiveTv;